module.exports = __webpack_public_path__ + "img/dish-1.2d69a2f5.png";